import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { all, and, equals, not, path, prop } from "ramda"

const getSessionId = () => {
  if (typeof window !== 'undefined') {
    const key = localStorage.getItem('@you:sessionId')
    return JSON.parse(key)
  }
  return
}

const getLocale = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('@MT:locale')
  }
  return 'en'
}

const HOST = process.env.REACT_APP_PUBLIC_YOU_API_HOST

const baseQuery = fetchBaseQuery({
  baseUrl: `${HOST}`,
  prepareHeaders: headers => {
    headers.set('Accept', 'application/json')
    headers.set('X-Session-Id', getSessionId())
    headers.set('locale', getLocale())
    return headers
  }
})

const pathname = window.location.pathname
// const onPrivateRoute = all(equals(true))([
//   not(equals(pathname, '/')),
//   not(onPublicRoute(pathname)),
//   not(onAuthRoute(pathname)),
//   privateRoutes.some(route => pathname.includes(route))
// ])

const baseQueryWithAuth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions)
  if (
    and(prop('error', result), equals(path(['error', 'status'], result), 401))
  ) {
    document.cookie = 'sessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    // if (onPrivateRoute) {
    //   localStorage.setItem('redirect', `${pathname}${window.location.search}`)
    // }
    // On 401 send user to sign in
    window.location.href = '/sign-in'
  }
  return result
}

export const api = createApi({
  baseQuery: baseQueryWithAuth,  
  endpoints: () => ({}),
  reducerPath: 'api',
  tagTypes: [
    'new cards',
    'card',
    'cards',
    'challenge card',
    'campus goals',
    'completed goals',
    'goal',
    'goals',
    'profile questions',
    'pick up cards',
    'user domains',
    'user',
    'reality score',
    'panic card',
    'school',
    'scores',
    'score',
    'self check',
    'about',
    'favorites',
    'student content',
    'geolocation resources',
    'featured content',
    'featured',
    'about',
    'be stats',
    'role types',
    'subdomain',
    'geo location',
    'public subdomain',
    'public user domains',
    'card sentiment',
    'legalDoc',
    'referral links'
  ]
})
